import {
    STOCK_TAKING_CAR_MANAGEMENT_CLEAR_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAILURE,
    STOCK_TAKING_CAR_MANAGEMENT_CLEAR_SUCCESS
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_CLEAR_BEGIN:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_CLEAR_SUCCESS:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
            currentTakingCar: null
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAILURE:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
          }
        }
      default:
        return state
    }
  }
  